import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { configSectionsInOut } from 'animations-lib';
import { FieldMetaTypeGuards } from '../../../../../interfaces/FieldMetaTypeGuards';
import { IFieldMeta } from '../../../../../interfaces/imetadata';
import { FieldConfigChangedControllerService } from '../../../data-fields/field-config-changed-controller.service';

@Component({
    selector: 'app-presentation-options',
    templateUrl: './presentation-options.component.html',
    styleUrls: ['../field-options.component.scss'],
    animations: [configSectionsInOut],
    standalone: false
})
export class PresentationOptionsComponent implements OnInit {
  @Input()
  set field(field: IFieldMeta | undefined) {
    this.theField = field;
    this.generateOptionsDescription();
    this.hasChanged = false;
  }

  get field(): IFieldMeta | undefined {
    return this.theField;
  }

  @Input() set fieldOptions(useDisplayValue: boolean | undefined) {
    this.useDisplayValue = !!useDisplayValue;
  }
  @Output() fieldOptionsChange = new EventEmitter<boolean>();

  expanded = false;
  hasChanged = false;
  optionsDescription = '';
  theField: IFieldMeta | undefined;
  useDisplayValue = true;

  constructor(private configChangedControllerService: FieldConfigChangedControllerService) {}

  ngOnInit() {
    this.hasChanged = this.configChangedControllerService.get('PresentationOptionsComponent');
  }

  updateParent() {
    this.fieldOptionsChange.emit(this.useDisplayValue);
    this.configChangedControllerService.update('PresentationOptionsComponent', true);
    setTimeout(() => (this.hasChanged = true), 0);
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }

  private generateOptionsDescription(): void {
    if (!FieldMetaTypeGuards.hasOptions(this.field)) {
      this.optionsDescription = '';
      return;
    }

    // E.g. Values are U,M,F and Display Values are Unknown, Male, Female

    const values = this.field.options
      .map((o) => o.value)
      .slice(0, 3)
      .join(', ');
    const labels = this.field.options
      .map((o) => o.label)
      .slice(0, 3)
      .join(', ');
    const ellipsis = this.field.options.length > 3 ? '...' : '';

    this.optionsDescription = `Values are ${values}${ellipsis} and Display Values are ${labels}${ellipsis}`;
  }
}
